import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CasingPlan2dBaseComponent } from '../casing-plan-2d-base.component';
import { CasingPlan2dDetailBaseComponent } from '../detail/casing-plan-2d-detail-base.component';

import { CasingTypeModel, WellSegmentModel, CasingType, Position } from "../../../new-casing-plan/models/casing-plan.model";
import { isDefined } from "../../../new-casing-plan/models/casing-plan-functions.model";


@Component({
    selector: 'casing-plan-2d-detail-vertical',
    templateUrl: './casing-plan-2d-detail.component.html',
    styleUrls: ['./casing-plan-2d-detail.component.scss'],
    standalone: false
})
export class CasingPlan2dDetailVerticalComponent extends CasingPlan2dDetailBaseComponent implements OnInit {


    public cementTopLabelPosition: Position;
    public cementBottomLabelPosition: Position;

    halfCasingWidth: number = 30;

    constructor() {
        super();
    }

    ngOnInit() {

        this.direction = "vertical";
        this.leftArrow.src = "../../../../../assets/images/SVG/arrow-left.svg";
        this.rightArrow.src = "../../../../../assets/images/SVG/arrow-right.svg"; 
        this.updateCanvas();
    }

    updateCanvas(): void {
        //set h/w
        this.canvasWidth = this.canvasRef.nativeElement.width;
        this.canvasHeight = this.canvasRef.nativeElement.height;

        //set factor for converting feet to pixels
        this.setfeetToPixelFactor(this.segment);
        //set canvas
        this.ctx = this.canvasRef.nativeElement.getContext('2d');
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        //set center
        this.center = this.canvasWidth / 2;
        //set right casing pos
        this.rightCasing = this.center + this.halfCasingWidth;
        //set left casing pos
        this.leftCasing = this.center - this.halfCasingWidth;
        //set right borehole
        this.rightBorehole = this.rightCasing + this.diagramCasingWidth;
        //set left borehole
        this.leftBorehole = this.leftCasing - this.diagramCasingWidth;
        
        this.casingLength = ((this.segment.casingBottom - this.segment.casingTop) * this.factorFeetToPixels) + this.canvasMarginTop;

        this.addWhiteBackground();

        if (this.hasCement(this.segment)) {
            //add bottom block of cement
            this.addCementBottom(this.segment);    
            //create method to calculate right and left casing cement
            this.addCementFillingAndLabels(this.segment);            
        }   

        if (this.hasCasing(this.segment)) {
            //add casing and labels        
            this.addCasing(this.segment);
        }

        //add outer cement border & labels
        this.addBoreHole(this.segment);

        //add shoe?
        if (this.hasValidValue(this.segment.casingShoeDepth, 'number')) {
            //shoes are offset 100% (not 50%) vertically so when a shoe is at the end of the casing it looks correct!
            //shoes at the bottom of the casing always - 4/1/19
            let shoeLocation = this.casingLength - this.shoeHW;
            this.addShoeToCanvas(this.ctx, shoeLocation, this.rightCasing, this.leftCasing - this.shoeHW, true);
        }

        let top = isDefined(this.segment.boreholeTop) ? this.segment.boreholeTop : this.segment.casingTop;
        //add packer?
        if (this.hasValidValue(this.segment.packerDepth, 'number')) {            
            let packerLocation = ((this.segment.packerDepth - top) * this.factorFeetToPixels) + this.canvasMarginTop - (.5 * this.packerH);
            this.addPackerToCanvas(this.ctx, packerLocation, this.rightCasing - this.diagramCasingWidth, this.leftCasing, true);
        }

        //add basket?
        if (this.hasValidValue(this.segment.basketDepth, 'number')) {
            let basketLocation = ((this.segment.basketDepth - top) * this.factorFeetToPixels) + this.canvasMarginTop - (.5 * this.basketHW);
            this.addBasketToCanvas(this.ctx, basketLocation, this.rightCasing, this.leftCasing, true);
        }

        //add collar?
        if (this.hasValidValue(this.segment.floatCollarDepth, 'number')) {
            let collarLocation = ((this.segment.floatCollarDepth - top) * this.factorFeetToPixels) + this.canvasMarginTop - (.5 * this.collarH);
            this.addCollarToCanvas(this.ctx, collarLocation, this.rightCasing, this.leftCasing - this.diagramCasingWidth, true);
        }

        //bottom line of well segment
        this.addSegmentBottom(this.segment);

        //draw arrows for borehole and casing width
        this.addDiameterArrows(this.segment);

        //draw vertical dashed lines for borehole and casing
        this.addDashedLines();

        //add top ground lines
        this.addGround(this.segmentIndex);

    }
    
}
